var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#B3C8E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 10.5C26.7022 10.5 27.283 10.74 27.7715 11.2285C28.26 11.717 28.5 12.2978 28.5 13C28.5 13.7022 28.26 14.283 27.7715 14.7715C27.283 15.26 26.7022 15.5 26 15.5C25.6798 15.5 25.3765 15.4411 25.0869 15.3242C24.7899 15.2042 24.522 15.0382 24.2812 14.8252L24.0107 14.5859L23.6982 14.7676L16.6484 18.8682L16.2969 19.0723L16.4258 19.458C16.4474 19.5228 16.4662 19.6041 16.4795 19.7041C16.4935 19.8094 16.5 19.908 16.5 20C16.5 20.0921 16.4936 20.1916 16.4795 20.2979C16.4662 20.3982 16.4477 20.478 16.4268 20.54L16.2959 20.9268L16.6484 21.1318L23.6982 25.2324L24.0107 25.4131L24.2812 25.1748C24.522 24.9625 24.7898 24.7968 25.0869 24.6768C25.3765 24.5598 25.6798 24.5007 26 24.5C26.7022 24.5 27.283 24.74 27.7715 25.2285C28.26 25.717 28.5 26.2978 28.5 27C28.5 27.7022 28.26 28.283 27.7715 28.7715C27.283 29.26 26.7022 29.5 26 29.5C25.2978 29.5 24.717 29.26 24.2285 28.7715C23.74 28.283 23.5 27.7022 23.5 27C23.5 26.9072 23.5065 26.8083 23.5205 26.7031C23.5338 26.6032 23.5529 26.5226 23.5742 26.459L23.7041 26.0723L23.3516 25.8682L16.3018 21.7676L15.9893 21.5869L15.7188 21.8252C15.4778 22.0377 15.2096 22.2035 14.9121 22.3242C14.623 22.4415 14.3205 22.5005 14.001 22.5H14C13.2978 22.5 12.717 22.26 12.2285 21.7715C11.74 21.283 11.5 20.7022 11.5 20C11.5 19.2978 11.74 18.717 12.2285 18.2285C12.717 17.74 13.2978 17.5 14 17.5C14.3199 17.5 14.6227 17.5593 14.9121 17.6768C15.21 17.7976 15.4787 17.9636 15.7197 18.1758L15.9902 18.4131L16.3018 18.2324L23.3516 14.1318L23.7031 13.9277L23.5742 13.542C23.5525 13.477 23.5338 13.396 23.5205 13.2969C23.5066 13.1926 23.5 13.0937 23.5 13C23.5 12.2978 23.74 11.717 24.2285 11.2285C24.717 10.74 25.2978 10.5 26 10.5Z",
    fill: "#0B4F9F",
    stroke: "#0B4F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.241af5aa55b36f5906601a5afacf2c25.svg";
export { ForwardRef as ReactComponent };